import React from 'react';
import RoutingSelect from './RoutingSelect.jsx';
import NotificationBell from './NotificationBell.jsx';
import AccountMenu from './AccountMenu.jsx';
import PhoneLauncher from './PhoneLauncher.jsx';

/**
 * The single, global top-right cluster (rendered once by Layout so it is on
 * every page): availability · bell · Welcome menu · phone launcher.
 * @returns {JSX.Element}
 */
export default function HeaderCluster() {
  return (
    <div className="flex items-center gap-2 shrink-0" data-testid="header-cluster">
      <RoutingSelect />
      <NotificationBell />
      <AccountMenu />
      <PhoneLauncher />
    </div>
  );
}
